export { default } from "ember-stereo/helpers/find-sound";
